var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import Rates from './Rate';
import { cssClassMap } from '../../../../constants/SportCssMap';
import HeaderOutcomePlace from './header-outcome-place-config.json';
import { winWithoutDraw } from './matchType';
import { getMomentLocale } from '../../../../shared/momentLocale';
var messages = defineMessages({
    grid_w1: {
        id: 'grid.w1',
        defaultMessage: 'П1'
    },
    grid_x: {
        id: 'grid.x',
        defaultMessage: 'X'
    },
    grid_w2: {
        id: 'grid.w2',
        defaultMessage: 'П2'
    },
});
var RenderEmptyCell = function () {
    return (_jsx("div", __assign({ className: 'rate' }, { children: _jsx("span", __assign({ className: 'metka' }, { children: "--" })) })));
};
var WITHOUT_TEAMS_NAME_MATCH_TYPES = [2, 3, 6];
var Match = /** @class */ (function (_super) {
    __extends(Match, _super);
    function Match() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Match.prototype.render = function () {
        var _a = this.props, match = _a.match, first = _a.first, outcome = _a.outcome, section = _a.section, gridLocalization = _a.gridLocalization, intl = _a.intl, languageId = _a.languageId;
        var sportId = match.get('sportId');
        var id = match.get('id');
        if (WITHOUT_TEAMS_NAME_MATCH_TYPES.includes(match.get('type'))) {
            return (_jsx("div", __assign({ className: "item ".concat(cssClassMap[sportId]) }, { children: _jsx("div", __assign({ className: 'name' }, { children: _jsx(Link, __assign({ to: "/event/".concat(id) }, { children: _jsxs("span", __assign({ className: 'player' }, { children: [" ", match.get('name')] })) })) })) })));
        }
        var timezone = moment.tz.guess();
        var firstTeam = match.get('firstTeam');
        var secondTeam = match.get('secondTeam');
        var notice = match.get('notice');
        var locale = getMomentLocale(languageId);
        var date = moment(match.get('startDate')).locale(locale).tz(timezone).format('DD MMMM HH:mm');
        var outcomeRates = outcome ? outcome.get('rates').toArray() : [];
        var outcomesCount = match.get('outcomesCount');
        var ifFirst = first ? ' first' : '';
        var renderRates = [];
        var props = {
            section: section,
            gridLocalization: gridLocalization
        };
        if (outcomeRates.length === 2) {
            renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[0], first: first, outcomeName: intl.formatMessage(messages.grid_w1) }, props), '1'));
            if (!winWithoutDraw.find(function (m) { return m === sportId; })) {
                renderRates.push(_jsx("div", __assign({ className: 'rate' }, { children: _jsx("span", __assign({ className: 'metka' }, { children: first && _jsx("span", __assign({ className: 'label' }, { children: _jsx(FormattedMessage, __assign({}, messages.grid_x)) })) })) }), '2'));
            }
            renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[1], first: first, outcomeName: intl.formatMessage(messages.grid_w2) }, props), '3'));
        }
        else if (outcomeRates.length === 3) {
            renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[0], first: first, outcomeName: intl.formatMessage(messages.grid_w1) }, props), '1'));
            if (!winWithoutDraw.find(function (m) { return m === sportId; })) {
                renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[1], first: first, outcomeName: intl.formatMessage(messages.grid_x) }, props), '2'));
            }
            renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[2], first: first, outcomeName: intl.formatMessage(messages.grid_w2) }, props), '3'));
        }
        else {
            renderRates.push(_jsx(RenderEmptyCell, {}, 'empty-cell-1'));
            if (!winWithoutDraw.find(function (m) { return m === sportId; })) {
                renderRates.push(_jsx(RenderEmptyCell, {}, 'empty-cell-2'));
            }
            renderRates.push(_jsx(RenderEmptyCell, {}, 'empty-cell-3'));
        }
        var cls = winWithoutDraw.find(function (m) { return m === sportId; }) ? ' win-without-draw' : '';
        return (_jsx("div", __assign({ className: "item ".concat(cssClassMap[sportId]).concat(ifFirst) }, { children: _jsxs("div", { children: [_jsx("div", __assign({ className: "name".concat(cls) }, { children: _jsxs(Link, __assign({ to: "/event/".concat(id) }, { children: [_jsx("span", __assign({ className: 'player' }, { children: firstTeam })), _jsx("span", __assign({ className: 'player' }, { children: secondTeam })), notice && _jsx("span", __assign({ className: 'sub' }, { children: notice })), _jsxs("span", __assign({ className: 'sub' }, { children: [date, _jsx("span", __assign({ className: "sub__count" }, { children: outcomesCount }))] }))] })) })), _jsx("div", __assign({ className: "rates".concat(cls) }, { children: renderRates }))] }) })));
    };
    Match.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        section: PropTypes.string.isRequired,
        match: PropTypes.object.isRequired,
        outcome: PropTypes.object,
        intl: PropTypes.object.isRequired,
        first: PropTypes.bool
    };
    return Match;
}(React.Component));
var mapStateToProps = function (state, props) { return ({
    languageId: state.application.get('languageId'),
    match: state.application.getIn([props.section, 'matches', props.id]),
    outcome: state.application.getIn([props.section, 'outcomes']).find(function (m) {
        return m.get('matchId') === props.id && HeaderOutcomePlace[m.get('type')] === 1;
    })
}); };
Match = connect(mapStateToProps)(Match);
export default injectIntl(Match);



// WEBPACK FOOTER //
// ./src/components/grid/common/sportsGrid/Match.jsx